/**
 * Arşivle / arşivden geri yükle akışı: onay penceresi → store action'ı → sonuç penceresi.
 * Store modülünde `archiveData` ve `restoreData` action'ları bulunmalı.
 * İptal edilirse `null`, aksi halde action sonucunu ({ status, message }) döner.
 */
export default {
  methods: {
    changeArchive(module, id, archive) {
      return this.$swal({
        title: 'Uyarı!',
        text: archive
          ? 'Kayıt arşive taşınacak, arşivdeyken düzenlenemez. Devam etmek istiyor musunuz?'
          : 'Kayıt arşivden çıkarılıp listeye geri alınacak. Devam etmek istiyor musunuz?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Devam Et',
        cancelButtonText: 'Vazgeç',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (!result.value) {
          return null
        }
        return this.$store.dispatch(`${module}/${archive ? 'archiveData' : 'restoreData'}`, id)
          .then(res => {
            const success = !!(res && res.status)
            let text = (res && res.message) || 'Sistem hatası oluştu.'
            if (success) {
              text = archive ? 'Kayıt arşive taşındı.' : 'Kayıt arşivden geri yüklendi.'
            }
            this.$swal({
              icon: success ? 'success' : 'error',
              title: success ? 'İşlem Başarılı!' : 'İşlem Hatası!',
              text,
              confirmButtonText: 'Kapat',
              customClass: {
                confirmButton: success ? 'btn btn-success' : 'btn btn-primary',
              },
            })
            return res
          })
      })
    },
  },
}
